import { http } from "@/lib/api";

const params = (obj = {}) => {
  const out = {};

  Object.entries(obj).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      value !== "All"
    ) {
      out[key] = value;
    }
  });

  return out;
};

export const expenseApi = {
  categories: async () =>
    (await http.get("/api/expenses/categories")).data,

  list: async (opts = {}) =>
    (
      await http.get("/api/expenses", {
        params: params(opts),
      })
    ).data,

  count: async (opts = {}) =>
    (
      await http.get("/api/expenses/count", {
        params: params(opts),
      })
    ).data,

  create: async (payload) =>
    (await http.post("/api/expenses", payload)).data,

  update: async (id, patch) =>
    (
      await http.patch(
        `/api/expenses/item/${encodeURIComponent(id)}`,
        patch
      )
    ).data,

  remove: async (id) =>
    (
      await http.delete(
        `/api/expenses/item/${encodeURIComponent(id)}`
      )
    ).data,

  summary: async () =>
    (
      await http.get(
        "/api/expenses/summary/dashboard"
      )
    ).data,

  analyticsMonthly: async (months = 6) =>
    (
      await http.get(
        "/api/expenses/analytics/monthly",
        {
          params: { months },
        }
      )
    ).data,

  analyticsCategory: async (month) =>
    (
      await http.get(
        "/api/expenses/analytics/category",
        {
          params: params({ month }),
        }
      )
    ).data,

  analyticsWeekly: async (days = 14) =>
    (
      await http.get(
        "/api/expenses/analytics/weekly",
        {
          params: { days },
        }
      )
    ).data,

  analyticsPayment: async (month) =>
    (
      await http.get(
        "/api/expenses/analytics/payment",
        {
          params: params({ month }),
        }
      )
    ).data,

  getBudget: async (month) =>
    (
      await http.get(
        "/api/budget",
        {
          params: params({ month }),
        }
      )
    ).data,

  setBudget: async (amount, month) =>
    (
      await http.post(
        "/api/budget",
        {
          amount,
          month,
        }
      )
    ).data,

  exportExcelUrl: (opts = {}) => {
    const query = new URLSearchParams(
      params(opts)
    ).toString();

    const baseUrl = http.defaults.baseURL || "";

    return `${baseUrl}/api/expenses/export/excel${
      query ? `?${query}` : ""
    }`;
  },

  backup: async () =>
    (
      await http.get(
        "/api/expenses/backup"
      )
    ).data,

  restore: async (payload) =>
    (
      await http.post(
        "/api/expenses/restore",
        payload
      )
    ).data,
};

export default expenseApi;